// Campus photo for /colleges/university-of-california-santa-cruz: CC BY-SA 4.0, by Ponderosapine210, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMerrill_College_Courtyard.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-santa-cruz/; credited under the photo.
const photo = {
    "slug": "university-of-california-santa-cruz",
    "alt": "The courtyard of Merrill College among redwoods at UC Santa Cruz in Santa Cruz, California",
    "src": "/colleges/university-of-california-santa-cruz/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-santa-cruz/campus-800.webp",
    "srcMid": "/colleges/university-of-california-santa-cruz/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-santa-cruz/og.jpg",
    "title": "Merrill College Courtyard",
    "author": "Ponderosapine210",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMerrill_College_Courtyard.jpg",
    "read": "2026-09-30"
};

export default photo;
